import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import * as types from './mutationTypes';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: '1234',
    schoolToken: '',
    adminToken: '',
    userToken: '',
    expertToken: '',
    keyword: '',
    userInfo: {},
    cacheData: {},
    isMobile: true,
    loading: true,
    authKey: 'Admin-Token',
    authRole: '',
    // adminSideMenu
    isCollapse: false,
    screenWidth: null,
    breadcrumbs: [],
  },
  mutations: {
    [types.SET_SCHOOL](state, payload) {
      state.schoolToken = payload;
    },
    [types.SET_EXPERT](state, payload) {
      state.expertToken = payload;
    },
    [types.SET_ADMIN](state, payload) {
      state.adminToken = payload;
    },
    [types.SET_USER](state, payload) {
      state.userToken = payload;
    },
    [types.SET_LOADING](state, payload) {
      state.loading = payload;
    },
    [types.SET_KEYWORD](state, payload) {
      state.keyword = payload;
    },
    [types.SET_USERINFO](state, payload) {
      state.userInfo = payload;
    },
    [types.SET_CACHEDARA](state, payload) {
      state.cacheData = payload;
    },
    [types.WATCH_SCREEEN_WIDTH](state, payload) {
      state.isMobile = payload;
    },
    [types.SET_AUTHKEY](state, payload) {
      state.authKey = payload;
    },
    [types.SET_AUTHROLE](state, payload) {
      state.authRole = payload;
    },
    [types.SET_BREADCRUMBS](state, payload) {
      state.breadcrumbs = payload;
    },
    // adminSideMenu
    [types.TOGGLE_SIDE_MENU](state, payload) {
      state.isCollapse = payload;
    },
    [types.SET_SCREENWIDTH](state, payload) {
      state.screenWidth = payload;
    },
  },
  actions: {
    setAdmin({ commit }, payload) {
      commit(types.SET_ADMIN, payload);
    },
    setSchool({ commit }, payload) {
      commit(types.SET_SCHOOL, payload);
    },
    setExpert({ commit }, payload) {
      commit(types.SET_EXPERT, payload);
    },
    setUser({ commit }, payload) {
      commit(types.SET_USER, payload);
    },
    setUserInfo({ commit }, payload) {
      commit(types.SET_USERINFO, payload);
    },
    isMobile({ commit }, payload) {
      commit(types.WATCH_SCREEEN_WIDTH, payload);
    },
    setCacheData({ commit }, payload) {
      commit(types.SET_CACHEDARA, payload);
    },
  },
  getters: {
    httpAdminHeader(state) {
      return {
        Accept: 'application/json',
        [state.authKey]: state.adminToken,
      };
    },
    httpUserHeader(state) {
      return {
        Accept: 'application/json',
        'User-Token': state.userToken,
      };
    },
    httpSchoolHeader(state) {
      return {
        Accept: 'application/json',
        'School-Token': state.schoolToken,
      };
    },
    httpExpertHeader(state) {
      return {
        Accept: 'application/json',
        'Expert-Token': state.expertToken,
      };
    },
    httpHeader() {
      return {
        Accept: 'application/json',
      };
    },
    httpUserHeaderUploader(state) {
      return {
        Accept: 'application/json',
        'User-Token': state.userToken,
      };
    },
    httpAdminHeaderUploader(state) {
      return {
        Accept: 'application/json',
        [state.authKey]: state.adminToken,
      };
    },
  },
  plugins: [
    createPersistedState({
      paths: ['authKey', 'authRole', 'adminToken', 'userToken', 'schoolToken', 'expertToken', 'token', 'cacheData', 'userInfo', 'isMobile', 'breadcrumbs'],
    }),
  ],
});



// WEBPACK FOOTER //
// ./src/store/index.js